<template>
  <v-autocomplete
    v-model="selected"
    :items="organizationUsers"
    :filter="customFilter"
    item-text="first_name"
    item-value="uuid"
    label="User"
    hide-selected
    return-object
    :multiple="false"
  >
    <template v-slot:item="data">
      <v-list-item-icon>
        <v-icon>face</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-item-title>
        <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="data">{{data.item.first_name + ' ' + data.item.last_name}}</template>
    <template v-slot:append-outer>
      <v-btn color="success" @click="addUser">
        <v-icon left>add</v-icon>
        <span>Add</span>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    organizationUsers: { type: Array, required: true },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    customFilter(item, queryText) {
      const textOne = item.first_name.toLowerCase();
      const textTwo = item.last_name.toLowerCase();
      const textThree = item.email.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1
      );
    },
    addUser() {
      this.$emit("addUser", this.selected);
    },
  },
};
</script>

<style>
</style>